module.exports = __webpack_public_path__ + "static/media/attribute_resist_poison.cec37c72.png";